import { render, staticRenderFns } from "./MyRecentClaimsDashboardItemSba.vue?vue&type=template&id=5018d4e6&scoped=true&"
import script from "./MyRecentClaimsDashboardItemSba.vue?vue&type=script&lang=js&"
export * from "./MyRecentClaimsDashboardItemSba.vue?vue&type=script&lang=js&"
import style0 from "./MyRecentClaimsDashboardItemSba.vue?vue&type=style&index=0&id=5018d4e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5018d4e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VProgressCircular,VRow})
